import type {Colors} from '@travel-frontend/themes';

import {css} from '@emotion/react';
import styled from '@emotion/styled';

import {BannerMarkdown} from '@/components/BannerMarkdown';

type Props = {value: string; className?: string; textColor?: keyof Colors};

export const Subtitle = styled(({className, value}: Props) => (
  <div className={className}>
    <BannerMarkdown value={value} isInline />
  </div>
))(
  ({theme, textColor = 'contentInversePrimary'}) => css`
    text-wrap: pretty;
    font-family: ${theme.fontFamily};
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.125rem;
    color: ${theme.colors[textColor]};

    ${theme.respondTo(
      'md',
      css`
        font-size: 1rem;
      `
    )}

    ${theme.respondTo('lg', theme.typography.labelMedium)}

    ${theme.respondTo(
      'xl',
      css`
        font-size: 1.125rem;
        line-height: 1.5rem;
      `
    )}
  `
);
